import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./status-key.scss";

const StatusKey = ({ type, children, className, ...props }) => {
  const classNames = classnames(
    "status-key",
    {
      [`status-key--${type}`]: !!type,
    },
    className
  );
  return (
    <span className={classNames} {...props}>
      {children}
    </span>
  );
};

StatusKey.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["success", "warning", "error", "info"]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default StatusKey;
